import React from 'react';
import styled from 'styled-components';

// --- Styled Components ---

const ReceiptContainer = styled.div`
  border: 1px solid #e0e0e0;
  background-color: #fcfcfc;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  font-family: 'SFMono-Regular', Consolas, 'Courier New', monospace;
`;

const Header = styled.h3`
  font-size: 18px;
  font-weight: bold;
  color: #333; /* Darker color for emphasis */
  margin-top: 0;
  margin-bottom: 12px; /* Space below the header */
  padding-bottom: 8px;
  border-bottom: 2px solid #555; /* Subtle separation */
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const FeeLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #444;
  
  /* Add a little space between lines */
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

const FeeName = styled.span`
  color: #555;
`;

const FeeAmount = styled.span`
  font-weight: 500;
  color: #111;
`;

const Separator = styled.hr`
  border: none;
  border-top: 1px dashed #ccc;
  margin: 12px 0;
`;

const TotalLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #000;
`;

// --- Your React Component ---

const FeeSummary = () => {
  // 1. Store your fees in an array. This is cleaner to manage.
  const fees = [
    { name: 'Yassi Fee', amount: 2.20 },
    { name: 'CULS Fee', amount: 2.20 },
    { name: 'State Fee', amount: 12.00 },
    { name: 'NMVTIS Fee', amount: 6.00 },
  ];

  // Using the total from your image.
  const total = 20.40;

  // Developer Note: The line items provided ($2.20 + $2.20 + $12.00 + $6.00)
  // actually add up to $22.40, not $20.40. You may want to double-check
  // your data! The example below uses your displayed total of $20.40.

  return (
    <ReceiptContainer>
      <Header>Estimated Fees</Header>
      {/* 2. Map over the array to render each fee line */}
      {fees.map((fee) => (
        <FeeLine key={fee.name}>
          <FeeName>{fee.name}</FeeName>
          <FeeAmount>${fee.amount.toFixed(2)}</FeeAmount>
        </FeeLine>
      ))}

      {/* 3. Add the separator */}
      <Separator />

      {/* 4. Render the final total */}
      <TotalLine>
        <span>Total</span>
        <span>${total.toFixed(2)}</span>
      </TotalLine>
    </ReceiptContainer>
  );
};

export default FeeSummary;